<template>
  <div class="cf-xq">
    <div class="details-title">{{this.info.title}}</div>
    <table style="width: 100%;font-size: 18px;line-height: 50px;">
      <tr v-for="item in info.zd_sx">
        <td style="border: 1px solid #cccccc;border-left: none;text-align:right;font-weight: bold;width: 30%">
          <span style="margin-right: 10px;width: 70%">{{item}}</span>
        </td>
        <td style="border: 1px solid #cccccc;border-right: none">
          <span style="margin-left: 10px;">{{info[item]}}</span>
        </td>
      </tr>
    </table>
  </div>

</template>

<script>
import {getAction} from "@/api/manage";
export default {
  name: "Details",
  data(){
    return{
      info:{},
      url:{
        detailsByIdUrl:'/search/detailsById'
      }
    }
  },
  created() {
    this.getDetails(this.$route.params.id)
  },
  methods:{
    getDetails(id) {
      getAction(this.url.detailsByIdUrl, {id: id}).then(res => {
        if(res.success) {
          this.info = res.data;
          res.data.zd_sx.forEach((item,index) => {
            if(index==3){
              res.data.zd_sx.splice(4,0,'数据类型')
              this.$set(res.data, '数据类型', res.data.type_mc)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.cf-xq{
  width: 1200px;
  margin: 20px auto 50px auto;
  background: #FFFFFF;
  height: auto;
  min-height: calc(100vh - 240px);
  padding-top: 50px;
}
.details-title{
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
